import React from 'react';
import './index.scss';

const Page404 = () => {
  return <div className='page-404'>Page404</div>;
};

export default Page404;
